import { keyframes } from '@emotion/react';

export const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const breath = keyframes`
  50% { opacity: 0.5; }
`;

export const slideProgress = keyframes`
  0%   { left: -60%; width: 60%; }
  100% { left: 110%; width: 60%; }
`;

export const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
`;

/** Slide a right-edge panel in from its own width. Transform + opacity only,
 * so it composites on the GPU without triggering layout. */
export const slideInRight = keyframes`
  from { opacity: 0; transform: translateX(12px); }
  to   { opacity: 1; transform: translateX(0); }
`;
